<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Administração', 'link' : '/admin' }]"
    />

    <div v-if="loading" class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <template v-else-if="dados">
      <div class="d-flex flex-wrap justify-content-between align-items-start gap-3">
        <div>
          <h1 class="mb-1">{{ dados.tenant.name }}</h1>
          <span class="badge me-2" :style="{ background: estado.bg, color: estado.text }">{{ estado.label }}</span>
          <span class="text-muted small">{{ vencimento({ ...sub, state: sub.state }) }}</span>
        </div>
        <div class="d-flex flex-wrap gap-2">
          <a v-if="whats" :href="whats" target="_blank" rel="noopener" class="btn btn-outline-success btn-sm">
            <i class="bi bi-whatsapp me-1"></i>WhatsApp
          </a>
          <a v-if="dados.tenant.showcase_enabled && dados.tenant.slug" :href="'/v/' + dados.tenant.slug" target="_blank" rel="noopener" class="btn btn-outline-secondary btn-sm">
            <i class="bi bi-shop me-1"></i>Ver vitrine
          </a>
        </div>
      </div>
      <hr/>

      <div class="row g-3 mb-4">
        <!-- Assinatura -->
        <div class="col-lg-6">
          <div class="card h-100">
            <div class="card-body">
              <h2 class="h6 text-muted text-uppercase mb-3">Assinatura</h2>
              <dl class="row mb-0 small">
                <dt class="col-5">Plano</dt><dd class="col-7">{{ sub.plan_name }}</dd>
                <dt class="col-5">Teste grátis até</dt><dd class="col-7">{{ data(sub.trial_ends_at) }}</dd>
                <dt class="col-5">Pago até</dt><dd class="col-7">{{ data(sub.paid_until) }}</dd>
                <dt class="col-5">Dias restantes</dt><dd class="col-7">{{ sub.days_left ?? '—' }}</dd>
                <dt class="col-5">Total pago</dt><dd class="col-7">{{ money(totalPago) }}</dd>
              </dl>
            </div>
          </div>
        </div>

        <!-- Empresa -->
        <div class="col-lg-6">
          <div class="card h-100">
            <div class="card-body">
              <h2 class="h6 text-muted text-uppercase mb-3">Empresa</h2>
              <dl class="row mb-0 small">
                <dt class="col-5">Código</dt><dd class="col-7">#{{ dados.tenant.id }}</dd>
                <dt class="col-5">WhatsApp</dt><dd class="col-7">{{ dados.tenant.whatsapp || '—' }}</dd>
                <dt class="col-5">Vitrine</dt><dd class="col-7">{{ dados.tenant.showcase_enabled ? 'Ativa' : 'Desativada' }} · /v/{{ dados.tenant.slug || '—' }}</dd>
                <dt class="col-5">Frete automático</dt><dd class="col-7">{{ dados.tenant.freight_enabled ? 'Ativo' : 'Desativado' }}</dd>
                <dt class="col-5">Cliente desde</dt><dd class="col-7">{{ data(dados.tenant.created_at) }}</dd>
                <dt class="col-5">Última locação</dt><dd class="col-7">{{ dataHora(dados.last_rental_at) }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <!-- Uso -->
      <div class="row g-3 mb-4">
        <div v-for="c in contadores" :key="c.label" class="col-6 col-md">
          <div class="card text-center">
            <div class="card-body py-2">
              <div class="h5 mb-0">{{ c.valor }}</div>
              <div class="small text-muted">{{ c.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Usuários -->
      <h2 class="h5">Usuários</h2>
      <app-table :empty="dados.users.length === 0" empty-message="Nenhum usuário."
        :colunas="[{ label: 'Nome' }, { label: 'E-mail' }, { label: 'WhatsApp' }, { label: 'Nível' }, { label: 'Situação' }, { label: '' }]">
        <app-trow v-for="u in dados.users" :key="u.id" :data="[
          u.name,
          u.email,
          u.phone || '—',
          NIVEIS[u.level] || u.level,
          { type: 'boolean', value: u.active, trueLabel: 'Ativo', falseLabel: 'Inativo' }
        ]">
          <template #actions>
            <div class="d-flex gap-1 justify-content-end">
              <button class="btn btn-sm btn-outline-secondary" @click="abrirSenha(u)">
                <i class="bi bi-key me-1"></i>Trocar senha
              </button>
              <button v-if="!u.is_super_admin" class="btn btn-sm btn-primary" @click="entrarComo(u)" :disabled="entrando">
                <i class="bi bi-box-arrow-in-right me-1"></i>Entrar no painel
              </button>
            </div>
          </template>
        </app-trow>
      </app-table>

      <!-- Pagamentos -->
      <h2 class="h5 mt-4">Pagamentos</h2>
      <app-table :empty="dados.payments.length === 0" empty-message="Nenhum pagamento ainda."
        :colunas="[{ label: 'Data' }, { label: 'Período' }, { label: 'Valor', align: 'right' }, { label: 'Status' }, { label: 'Pago em' }, { label: 'Order Mercado Pago' }]">
        <app-trow v-for="p in dados.payments" :key="p.id" :data="[
          dataHora(p.created_at),
          periodo(p.months),
          { type: 'currency', value: p.amount, align: 'right' },
          badgePagamento(p.status),
          dataHora(p.paid_at),
          p.mp_order_id || '—'
        ]" />
      </app-table>
    </template>

    <!-- Modal: trocar senha -->
    <div class="modal fade" id="modal_senha" tabindex="-1" aria-labelledby="modalSenhaTitulo" aria-hidden="true">
      <div class="modal-dialog">
        <form class="modal-content" @submit.prevent="salvarSenha">
          <div class="modal-header">
            <h5 class="modal-title" id="modalSenhaTitulo">Trocar senha — {{ usuarioSenha?.name }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div class="modal-body">
            <label for="novaSenha" class="form-label">Nova senha</label>
            <div class="input-group">
              <input v-model="novaSenha" id="novaSenha" type="text" class="form-control font-monospace" required minlength="8" autocomplete="off">
              <button type="button" class="btn btn-outline-secondary" @click="gerarSenha">Gerar</button>
              <button type="button" class="btn btn-outline-secondary" @click="copiarSenha" :disabled="!novaSenha">Copiar</button>
            </div>
            <p class="small text-muted mt-2 mb-0">Mínimo de 8 caracteres. As sessões abertas desse usuário serão encerradas. Envie a nova senha ao cliente por um canal seguro.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary" :disabled="salvandoSenha">
              <span v-if="salvandoSenha" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Salvar senha
            </button>
          </div>
        </form>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { Modal } from "bootstrap";
import { admin } from '@/models/admin';
import { useAuth } from '@/services/auth';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import { ESTADOS, NIVEIS, badgePagamento, data, dataHora, money, periodo, vencimento, whatsappLink } from './adminHelpers';

export default {
  name: "AdminClientView",
  components: { PainelLayout, Breadcrumb, AppTable, AppTrow },
  setup() {

    const route = useRoute();
    const auth = useAuth();
    const toastStore = useToastStore();
    const model = admin();
    const loading = ref(false);
    const dados = ref(null);
    const entrando = ref(false);
    const usuarioSenha = ref(null);
    const novaSenha = ref('');
    const salvandoSenha = ref(false);
    let modalSenha = null;

    const sub = computed(() => dados.value?.subscription ?? {});
    const estado = computed(() => ESTADOS[sub.value.state] ?? ESTADOS.legacy);
    const totalPago = computed(() => (dados.value?.payments ?? [])
      .filter(p => p.status === 'APPROVED').reduce((s, p) => s + Number(p.amount), 0));
    const whats = computed(() => {
      const d = dados.value;
      if (!d) return null;
      const dono = d.users.find(u => u.level === 'adm' && u.phone);
      return whatsappLink(d.tenant.whatsapp || dono?.phone);
    });
    const contadores = computed(() => {
      const c = dados.value.counts;
      return [
        { label: 'Itens', valor: c.items },
        { label: 'Clientes', valor: c.clients },
        { label: 'Locações', valor: c.rentals },
        { label: 'Pedidos da vitrine', valor: c.orders },
        { label: 'Contratos', valor: c.contracts },
      ];
    });

    async function carregar() {
      loading.value = true;
      try {
        dados.value = await model.getOne(route.query.id);
      } catch (error) {
        toastStore.error('Erro ao carregar empresa: ' + parseError(error));
      }
      loading.value = false;
    }

    function abrirSenha(usuario) {
      usuarioSenha.value = usuario;
      gerarSenha();
      modalSenha = modalSenha ?? new Modal(document.getElementById('modal_senha'));
      modalSenha.show();
    }

    // Senha aleatória legível (sem caracteres ambíguos)
    function gerarSenha() {
      const chars = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ23456789';
      const bytes = new Uint32Array(10);
      crypto.getRandomValues(bytes);
      novaSenha.value = Array.from(bytes, b => chars[b % chars.length]).join('');
    }

    async function copiarSenha() {
      try {
        await navigator.clipboard.writeText(novaSenha.value);
        toastStore.success('Senha copiada.');
      } catch (e) {
        toastStore.warning('Não foi possível copiar. Selecione e copie manualmente.');
      }
    }

    async function salvarSenha() {
      salvandoSenha.value = true;
      try {
        await model.resetPassword(usuarioSenha.value.id, novaSenha.value);
        toastStore.success('Senha de ' + usuarioSenha.value.name + ' alterada.');
        modalSenha.hide();
      } catch (error) {
        toastStore.error(parseError(error));
      }
      salvandoSenha.value = false;
    }

    async function entrarComo(usuario) {
      if (!confirm(`Entrar no painel de ${dados.value.tenant.name} como ${usuario.name}?\n\nTudo o que você fizer ficará registrado como esse usuário. O acesso de suporte expira em 2 horas.`)) return;
      entrando.value = true;
      try {
        auth.startImpersonation(await model.impersonate(usuario.id));
      } catch (error) {
        toastStore.error(parseError(error));
        entrando.value = false;
      }
    }

    onMounted(carregar);

    return {
      loading, dados, sub, estado, totalPago, whats, contadores, entrando,
      usuarioSenha, novaSenha, salvandoSenha,
      abrirSenha, gerarSenha, copiarSenha, salvarSenha, entrarComo,
      NIVEIS, badgePagamento, data, dataHora, money, periodo, vencimento
    }
  }
}
</script>
